export default "__VITE_ASSET__9e1c107b__"